import {
  SET_COUNTRIES_LIST,
  CLEAR_DATA,
  STORE_TESTIMONIAL,
  STORE_FAQ,
  STORE_PAGINATION,
  STORE_META, STORE_BREADCRUMB, STORE_INTERNAL_LINKS
} from './mutation-types'

export default {
  [SET_COUNTRIES_LIST] (state, data) {
    state.countries_list = data
  },
  [CLEAR_DATA] (state) {
    state.countries_list = null
  },
  [STORE_TESTIMONIAL] (state, data) {
    state.testimonials = data
  },
  [STORE_FAQ] (state, data) {
    state.faq = data
  },
  [STORE_PAGINATION] (state, data) {
    state.pagination = data
  },
  [STORE_META] (state, data) {
    state.meta = data
  },
  [STORE_BREADCRUMB] (state, data) {
    state.breadcrumb = data
  },
  [STORE_INTERNAL_LINKS] (state, data) {
    state.internalLinks = data
  }
}
